<template>
  <input type="text" class="form-control input-sm" :value="val" v-on:input="onInput" :maxlength="maxLength">
</template>
<script>
  export default {
    props: [
      'maxLength',
      'val'
    ],
    data: function () {
      return {
      }
    },
    methods: {
      onInput (e) {
        // 親のv-bindを更新
        var value = e.target.value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
          return String.fromCharCode(s.charCodeAt(0) - 65248)
        })
        this.$emit('input', value)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// TextNumber.vue?6461cb30